import { useContext } from 'react';
import { GlobalContext } from '../api/GlobalContext';
import { useNavigate } from 'react-router-dom';

const CrispChat = () => {
  const { apiClient } = useContext(GlobalContext);
  const navigate = useNavigate();
  const chatPage = apiClient?.features?.['zendesk_support_chat']
    ? 'zendesk-chat.html'
    : 'crisp-chat.html';

  const handleClose = () => {
    navigate('/User/home');
  };

  return (
    <>
      <button
        onClick={handleClose}
        style={{
          position: 'fixed',
          top: '10px',
          right: '10px',
          zIndex: 10000,
          background: '#f44336',
          color: 'white',
          border: 'none',
          padding: '2px 5px',
          borderRadius: '2px',
          cursor: 'pointer'
        }}
      >
        Close
      </button>
      <iframe
        src={`https://app.comprehendpt.com/${chatPage}?name=${encodeURIComponent(apiClient.name)}&email=${encodeURIComponent(apiClient.email)}&emr=${encodeURIComponent(apiClient.EMR || '')}`}
        style={{
          width: '100%',
          height: '100vh',
          border: 'none',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 9999
        }}
        title="Crisp Chat"
      />
    </>
  );
};

export default CrispChat;
